import { useEffect, useState } from "react";
import { breakpoints } from "../theme";

/**
 * Kırılım noktası takibi.
 *
 * NEDEN `matchMedia`, `window.innerWidth` + resize dinleyicisi DEĞİL: tarayıcı
 * yalnızca eşik GEÇİLDİĞİNDE haber verir. Resize dinleyicisi her karede
 * setState çağırıp bütün ağacı yeniden çizdiriyordu.
 *
 * Başlangıç değeri ilk render'da okunur, effect'e bırakılmaz: aksi hâlde telefonda
 * sayfa önce masaüstü düzeniyle boyanıp hemen ardından zıplıyor.
 */
const useMediaBreakpoint = (maxWidth: number): boolean => {
  const query = `(max-width: ${maxWidth}px)`;

  const [matches, setMatches] = useState<boolean>(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    // İlk render ile effect arasında eşik değişmiş olabilir (ör. ekran döndürme).
    setMatches(mediaQuery.matches);

    const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
};

/** Telefon: tablolar kart listesine döner, dolgular küçülür. */
const useIsMobile = () => useMediaBreakpoint(breakpoints.mobile);

/** Telefon + dar tablet: sidebar üstüne binen çekmeceye döner. */
export const useIsCompact = () => useMediaBreakpoint(breakpoints.compact);

export default useIsMobile;
